import React, {Component} from 'react'
import FontAwesome from 'react-fontawesome'
import {Link} from 'react-router-dom'
import { withStyles } from '@material-ui/styles';

const styles = (theme) => ({
  logoLink: {
    fontSize: 24,
    height: 60,
  },
  logo: {
    height: 60,
    marginTop: 1,
  },
})
const Logo = (props)=> {
  const { classes } = props;

  return (
    <Link to="/" className="logo">
      <img src='/favicon.png' className={classes.logo}/>
    </Link>
  )

}

export default withStyles(styles)(Logo)



// WEBPACK FOOTER //
// ./src/components/Logo.jsx